<div class="transaction-detail-container">
  <div *ngIf="processing()" class="overlay">
    <mat-progress-spinner mode="indeterminate" diameter="60"></mat-progress-spinner>
  </div>

  <div class="error" *ngIf="errorMessage && !loading()">
    <div class="error-card">
      <h3>{{ 'GLOBAL.ERROR' | translate }}</h3>
      <p>{{ errorMessage }}</p>
    </div>
  </div>

  <div class="content" *ngIf="!loading() && !errorMessage; else loadingTemplate">
    <div class="transaction-container" *ngIf="viewModel$ | async as vm">
      <div class="header">
        <h2>{{ 'TRANSACTION.TITLE' | translate }} <span class="item-details"> #{{ vm.notification.Transaction.TransactionID }}</span></h2> 
      </div>

      <div class="transaction-meta">
        <p>
          <strong>{{ 'TRANSACTION.STORE' | translate }}:</strong>
          {{ vm.notification.Transaction.SenderBusinessUnitName }}
        </p>
        <p>
          <strong>{{ 'TRANSACTION.CREATED' | translate }}:</strong>
          {{ vm.notification.Transaction.CreatedAt | date:'dd.MM.yyyy HH:mm' }}
        </p>
        <p>
          <strong>{{ 'TRANSACTION.STATUS' | translate }}:</strong>
          {{ 'APPROVE_STATUS.' + ApproveStatus[vm.notification.Transaction.Status] | translate }}
        </p>
      </div>

      <!-- Action/body section disabled - POS sends raw text with /n separators
      <div class="transaction-body" *ngIf="transaction.message">
        <p *ngFor="let line of splitLines(transaction.message)">{{ line }}</p>
      </div>
      -->
      <div class="item-list" *ngIf="vm.items.length">
        <h2>{{ 'TRANSACTION.ITEMS' | translate }} ({{ vm.items.length }}):</h2>
        <mat-card class="item-card" *ngFor="let item of vm.items; let i = index">

          <div class="item-name-row">
            <span class="item-name" *ngIf="parsedNotes[item.foreignItemID] as note">
              {{ note.name || item.requestNote }}
            </span>
            <span class="item-name" *ngIf="!parsedNotes[item.foreignItemID]">
              {{ item.requestNote }}
            </span>
          </div>

          <div class="item-details" *ngIf="parsedNotes[item.foreignItemID] as note">
            <p *ngIf="note.articleCode">
              <strong>{{ 'TRANSACTION.ARTICLE' | translate }}:</strong>
              {{ note.articleCode }}
            </p>
            <p *ngIf="note.ean">
              <strong>EAN:</strong>
              {{ note.ean }}
            </p>
            <p *ngIf="note.discountType">
              <strong>{{ 'TRANSACTION.DISCOUNT_TYPE' | translate }}:</strong>
              {{ note.discountType }}
            </p>
          </div>

          <div class="item-pricing">
            <div class="price-row">
              <span>{{ 'TRANSACTION.QTY' | translate }}</span>
              <span class="value">{{ item.quantity }}</span>
            </div>
            <div class="price-row" *ngIf="item.proposedUnitPrice">
              <span>{{ 'TRANSACTION.PRICE' | translate }}</span>
              <span class="value">{{ item.proposedUnitPrice | number:'1.2-2' }}</span>
            </div>
            <div class="price-row total" *ngIf="item.proposedUnitPrice">
              <span>{{ 'TRANSACTION.TOTAL' | translate }}</span>
              <span class="value">{{ (item.quantity * item.proposedUnitPrice) | number:'1.2-2' }}</span>
            </div>
          </div>

          <img *ngIf="item.imageUrl" [src]="item.imageUrl" class="item-thumb" alt="Item image" />

          <div class="item-actions">
            <ng-container *ngIf="!vm.readonly; else showBadgesOnly">
              <button class="approve" [class.faded]="item.status === ApproveItemStatus.Declined"
                [class.selected]="item.status === ApproveItemStatus.Approved" [disabled]="processing()"
                (click)="setItemStatus(item, ApproveItemStatus.Approved)">
                {{ 'TRANSACTION.APPROVE' | translate }}
              </button>

              <button class="decline" [class.faded]="item.status === ApproveItemStatus.Approved"
                [class.selected]="item.status === ApproveItemStatus.Declined" [disabled]="processing()"
                (click)="setItemStatus(item, ApproveItemStatus.Declined)">
                {{ 'TRANSACTION.DECLINE' | translate }}
              </button>
            </ng-container>

            <ng-template #showBadgesOnly >

              <span class="badge approved" *ngIf="item.status === ApproveItemStatus.Approved">
                <mat-icon>done</mat-icon> {{ 'TRANSACTION.ITEM_APPROVED' | translate }}
              </span>
              <span class="badge declined" *ngIf="item.status === ApproveItemStatus.Declined">
                <mat-icon>clear</mat-icon> {{ 'TRANSACTION.ITEM_DECLINED' | translate }}
              </span>
            </ng-template>
          </div>
        </mat-card>
      </div>

      <div class="transaction-actions" *ngIf="!vm.readonly">
        <button class="finalize-button" [disabled]="processing() || !vm.canFinalize" (click)="finalizeTransaction()">
          {{ 'TRANSACTION.FINALIZE' | translate }}
        </button>
      </div>
    </div>

    <div class="no-data" *ngIf="!(viewModel$ | async)">
      <p>{{ 'TRANSACTION.NO_TRANSACTION_TO_SHOW' | translate }}</p>
    </div>

    
  </div>

  <ng-template #loadingTemplate>
    <div class="loading">
      <div class="loading-spinner"></div>
      <p>{{ 'TRANSACTION.LOADING' | translate }}</p>
    </div>
  </ng-template>
</div>
